





















// tslint:disable-next-line:no-unused
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { dropdownThreeComponentEventBus } from '.';

const cssPrefix = 'dropdown-three-component-rows';

@Component({
  components: {
    DropdownThreeComponentRows,
  },
})
export default class DropdownThreeComponentRows extends SwExtendedVue{

  @Prop({ type: Boolean, default: false })
  disabled: boolean;

  @Prop({ type: Boolean, default: false })
  highlight: boolean;

  @Prop({ type: String, default: '' })
  selectContent: string;

  @Prop({ type: String, default: '' })
  selectProductGroupId: string;

  recentlySearched: string;
  productGroupId: string;
  cssPrefix = cssPrefix;
  spanStyle = {
    width: '150px',
  };

  created() {
  }

  selectContentFunction() {
    if (this.selectContent !== 'No results to display') {
      this.recentlySearched = this.selectContent;
      this.productGroupId = this.selectProductGroupId;
      this.$emit('clicked-show-recent', { selectedVal:this.recentlySearched, productGroupId:this.productGroupId });
      dropdownThreeComponentEventBus.$emit('clicked-show-recent', { selectedVal:this.recentlySearched, productGroupId:this.productGroupId });
    }
  }
}
